const TOKEN_KEY = 'fb_token'
const USER_KEY = 'fb_user_info'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getUserInfo() {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function setUserInfo(userInfo) {
  localStorage.setItem(USER_KEY, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  localStorage.removeItem(USER_KEY)
}

const REMEMBER_ACCOUNT_KEY = 'fb_remember_account'

export function getRememberAccount() {
  return localStorage.getItem(REMEMBER_ACCOUNT_KEY) || ''
}

export function setRememberAccount(account) {
  localStorage.setItem(REMEMBER_ACCOUNT_KEY, account)
}

export function removeRememberAccount() {
  localStorage.removeItem(REMEMBER_ACCOUNT_KEY)
}
